<template>
  <cs-form-dialog
    v-model="popupDialog"
    :heading="title"
    :primary-action="{ label: 'Close', eventName: 'dlg-cancel' }"
    @primary-click="popupDialog = false"
  >
    <template v-slot:cs-form-dialog-content>
      <span>{{ message }}</span>
    </template>
  </cs-form-dialog>
</template>

<script>
import { CSBase, CSFormDialog } from '@complispace/cs-design-system';
import TempPage from '../views/TempPage';

export default {
  name: 'CheckForUpdatesMessageDialog',
  components: { TempPage, CSFormDialog },
  extends: CSBase,

  props: {
    showDialog: { type: Boolean, required: true, default: false },
    message: { type: String, required: true },
    title: { type: String, required: true, default: 'No updates available' }
  },

  data() {
    return {
      popupDialog: false
    };
  },

  watch: {
    showDialog(value) {
      if (value) {
        this.popupDialog = true;
      }
    },

    popupDialog(value) {
      if (!value) {
        this.$emit('closed');
      }
    }
  }
};
</script>
